export const sourceOptions = [
  {
    text: 'Tiktok ads',
    textCn: 'Tiktok ads',
    value: 'exolyt',
  },
  {
    text: 'Tiktok Gaming',
    textCn: 'Tiktok Gaming',
    value: 'tiktok_gaming',
  },
];
